import { action } from 'typesafe-actions';
import ActionTypes, { TVideoState } from './types';

export const setVideo = (payload: TVideoState['isFullScreen']) => action(ActionTypes.SET_VIDEO, payload);
export const setVideoHide = (payload: TVideoState['isHideVideo']) => action(ActionTypes.SET_VIDEO_HIDE, payload);
